import React from "react";

const plans = [
{
    id: 1,
    type: "Custom Website",
    name: "Basic",
    price: "$80",
    features: [
      "2-page Custom Website",
      "Clean Design Layout",
      "Fully Responsive Design",
      "Fully Functional Website",
    ],
  },
  {
    id: 2,
    type: "Custom Website",
    name: "Standard",
    price: "$160",
    features: [
      "5-page Custom Website",
      "Contact Form Included",
      "Fully Responsive Design",
      "Fully Functional Website",
    ],
  },
  {
    id: 3,
    type: "Custom Website",
    name: "Advanced",
    price: "$250",
    features: [
      "8-page Custom Website",
      "Content & Logo Included",
      "Fully Responsive Design",
      "Fully Functional Website",
    ],
  },

  // 2️⃣ WordPress Website
  {
    id: 4,
    type: "WordPress Website",
    name: "Basic",
    price: "$60",
    features: [
      "2-3 Page WordPress Site",
      "Clean Design Layout",
      "Fully Responsive Design",
      "Fully Functional Website",
    ],
  },
  {
    id: 5,
    type: "WordPress Website",
    name: "Standard",
    price: "$140",
    features: [
      "5-page WordPress Site",
      "Contact Form Included",
      "Fully Responsive Design",
      "Fully Functional Website",
    ],
  },
  {
    id: 6,
    type: "WordPress Website",
    name: "Advanced",
    price: "$220",
    features: [
      "8-page WordPress Site",
      "Content & Logo Included",
      "Fully Responsive Design",
      "Fully Functional Website",
    ],
  },

  // 3️⃣ E-Commerce Website
  {
    id: 7,
    type: "E-Commerce Website",
    name: "Basic",
    price: "$350",
    features: [
      "Up to 10 Products",
      "Payment Integration",
      "Fully Responsive E-Commerce Websitee",
      "Fully Functional E-Commerce Website",
    ],
  },
  {
    id: 8,
    type: "E-Commerce Website",
    name: "Standard",
    price: "$450",
    features: [
      "Up to 25 Products",
      "Payment & Shipping Setup",
      "Fully Responsive E-Commerce Website",
      "Fully Functional E-Commerce Website",
    ],
  },
  {
    id: 9,
    type: "E-Commerce Website",
    name: "Advanced",
    price: "$600",
    features: [
      "Up to 50 Products",
      "Full Store Setup",
      "Fully Responsive E-Commerce Website",
      "Advanced E-Commerce Website",
    ],
  },

  // 4️⃣ SEO Packages
  // Custom Website SEO
  {
    id: 10,
    type: "SEO - Custom Website",
    name: "Basic",
    price: "$180",
    features: [
      "30-days SEO for 5 Pages",
      "30-Days Keyword Research",
      "Meta Titles Setup for Custom Website",
      "Google Console Custom Website",
    ],
  },
  {
    id: 11,
    type: "SEO - Custom Website",
    name: "Standard",
    price: "$280",
    features: [
      "30-Days SEO for 10 Pages",
      "30-Days Image Optimization",
      "Internal Linking Custom Website",
      "Sitemap Submission Custom Website",
    ],
  },
  {
    id: 12,
    type: "SEO - Custom Website",
    name: "Advanced",
    price: "$360",
    features: [
      "SEO for 20 Pages Custom Website",
      "Competitor Analysis Custom Website",
      "30-Days Backlink Recommendations",
      "30-Days Monthly Performance Report",
    ],
  },

  // WordPress Website SEO
  {
    id: 13,
    type: "SEO - WordPress Website",
    name: "Basic",
    price: "$80",
    features: [
      "WordPress Plugin Setup",
      "SEO for 5 Pages - WordPress website",
      "30-Days Meta Titles Setup",
      "30-Days Google Console Setup",
    ],
  },
  {
    id: 14,
    type: "SEO - WordPress Website",
    name: "Standard",
    price: "$160",
    features: [
      "30-Days SEO for 10 Pages",
      "30-Days Image Optimization",
      "Internal Linking - WordPress website",
      "Sitemap Submission WordPress website",
    ],
  },
  {
    id: 15,
    type: "SEO - WordPress Website",
    name: "Advanced",
    price: "$320",
    features: [
      "SEO for 20 Pages - WordPress website",
      "30-Days Competitor Analysis",
      "30-Days Backlink Recommendations",
      "Monthly Performance Report",
    ],
  },

  // 5️⃣ Logo Design
  {
    id: 16,
    type: "Logo Design",
    name: "Basic",
    price: "$50",
    features: [
      "Minimal Logo Design",
      "1 Initial Concept",
      "High-Resolution File",
      "Clean Professional Style",
    ],
  },
  {
    id: 17,
    type: "Logo Design",
    name: "Standard",
    price: "$80",
    features: [
      "2-3 Initial Concepts",
      "Modern Logo Style",
      "High-Resolution Files",
      "Professional Branding Ready",
    ],
  },
  {
    id: 18,
    type: "Logo Design",
    name: "Advanced",
    price: "$150",
    features: [
      "4-5 Initial Concepts",
      "Full Branding Guide",
      "Multiple File Formats",
      "Professional Logo Design",
    ],
  },

  // 6️⃣ Paid Ads Setup
  {
    id: 19,
    type: "Paid Ads Setup",
    name: "Basic",
    price: "$60+",
    features: [
      "Facebook Ads Setup",
      "Instagram Ads Setup",
      "Google Ads Setup",
      "Campaign Planning",
    ],
  },
  {
    id: 20,
    type: "Paid Ads Setup",
    name: "Standard",
    price: "$120+",
    features: [
      "Facebook Ads Management",
      "Instagram Ads Management",
      "Google Ads Management",
      "Audience Targeting",
    ],
  },
  {
    id: 21,
    type: "Paid Ads Setup",
    name: "Advanced",
    price: "$200+",
    features: [
      "Full Ads Management",
      "Advanced Targeting",
      "Remarketing Setup",
      "Monthly Reports",
    ],
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="py-5" style={{ background: "#1a1a2e", color: "#fff" }}>
      <div className="container text-center">
        <h2 className="fw-bold mb-3">Pricing Plans</h2>
        <p className="text-light mb-5">
          If none of these plans match your requirements, please share your details in the form below.
        </p>

        <div className="row g-4">
          {plans.map((plan) => (
            <div key={plan.id} className="col-md-4">
              <div className="p-4 rounded-4 shadow h-100" style={{ background: "#162447" }}>
                <div className="badge bg-warning text-dark mb-2">#{plan.id}</div>
                <h4 className="fw-bold text-warning">{plan.name}</h4>
                <h2 className="my-3">{plan.price}</h2>
                <ul className="list-unstyled mb-4 text-start">
                  {plan.features.map((f, i) => (
                    <li key={i} className="mb-2">{f !== "-" ? `✅ ${f}` : <span style={{ visibility: "hidden" }}>-</span>}</li>
                  ))}
                </ul>
                <a href="#contact" className="btn btn-warning fw-bold w-100">
                  Get Started
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
